<template>
  <div id="mobileFootter">
      <div class="aeroiotflex_row" style="padding: 14px 28px 0 28px;">
          <div class="mobileFootter-tip1">关注我们：</div>
          <div class="aeroiotflex_row" style="margin-right:48.5px" @click="openWxDialog">
              <img src="@/assets/wx.png" alt="" style="width:21px;height:21px;margin-right:9px">
              <div class="mobileFootter-tip2">微信</div>
          </div>
          <div class="aeroiotflex_row" @click="openDyDialog">
              <img src="@/assets/dy.png" alt="" style="width:21px;height:21px;margin-right:9px">
              <div class="mobileFootter-tip2">抖音</div>
          </div>
      </div>
      <div class="aeroiotflex_center">
          <div class="mobileFootter-tip3 aeroiotflex_center">
              免费咨询：400-770-0140
          </div>
      </div>
      <div class="aeroiotflex_center">
              <a href="https://hardware.aeroiot.cn/#/appguide">
                <div class="aeroiotflex_row">
                    <img src="@/assets/phone.png" alt="" style="width:10px;height:13.5px;margin-right:8px">
                    <div class="mobileFootter-tip4">
                        下载APP
                    </div>
                </div>
              </a>
      </div>
      <div class="mobileFootter-tip5 aeroiotflex_center" style="flex-direction: column;margin-top:10px">
          <div>COPYRIGHT © 2017 - 2021 云南航天工程物探检测股份有限公司</div>
          <div>股票代码 832007</div>
          <div>滇ICP备16005863号-2</div>
      </div>


            <el-dialog
            class="experienceButtonDialog experienceButtonDialog2"
            :visible.sync="wxDialog"
            :append-to-body="true"
            width="315px"
            :before-close="handleClose1"
        >
            <span slot="title"></span>
            <div class="aeroiotflex_col" style="align-items: center">
                <div
                    class="experienceButtonDialogRightIcon"
                    style="margin-bottom: 26px"
                >
                    <i class="el-icon-check"></i>
                </div>

                <div
                    style="
                        line-height: 24px;
                        text-algin: center;
                        color: #999999;
                        font-size: 12px;
                    "
                >
                    2个工作日内会有专属客户经理与您联系
                </div>
                <div
                    style="
                        line-height: 24px;
                        text-algin: center;
                        color: #999999;
                        font-size: 12px;
                    "
                >
                    请保持您的电话畅通如需提前开通其他需求
                </div>
                <div
                    style="
                        line-height: 24px;
                        text-algin: center;
                        color: #999999;
                        font-size: 12px;
                    "
                >
                    请联系<span
                        style="
                            font-size: 16px;
                            color: #6c85ff;
                            font-weight: 600;
                        "
                        >400-7700-140</span
                    >
                </div>

                <div
                    class="experienceButtonInDialog experienceButtonInDialog2"
                    style="margin-top: 30px"
                    @click="wxDialog = false"
                >
                    确认
                </div>
            </div>
        </el-dialog>
                <el-dialog
            class="experienceButtonDialog experienceButtonDialog2"
            :visible.sync="dyDialog"
            :append-to-body="true"
            width="315px"
            :before-close="handleClose2"
        >
            <span slot="title"></span>
            <div class="aeroiotflex_col" style="align-items: center">
                <div
                    class="experienceButtonDialogRightIcon"
                    style="margin-bottom: 26px"
                >
                    <i class="el-icon-check"></i>
                </div>

                <div
                    style="
                        line-height: 24px;
                        text-algin: center;
                        color: #999999;
                        font-size: 12px;
                    "
                >
                    2个工作日内会有专属客户经理与您联系
                </div>
                <div
                    style="
                        line-height: 24px;
                        text-algin: center;
                        color: #999999;
                        font-size: 12px;
                    "
                >
                    请保持您的电话畅通如需提前开通其他需求
                </div>
                <div
                    style="
                        line-height: 24px;
                        text-algin: center;
                        color: #999999;
                        font-size: 12px;
                    "
                >
                    请联系<span
                        style="
                            font-size: 16px;
                            color: #6c85ff;
                            font-weight: 600;
                        "
                        >400-7700-140</span
                    >
                </div>

                <div
                    class="experienceButtonInDialog experienceButtonInDialog2"
                    style="margin-top: 30px"
                    @click="dyDialog = false"
                >
                    确认
                </div>
            </div>
        </el-dialog>


  </div>
</template>

<script>
export default {
    data(){
        return{
            wxDialog:false,
            dyDialog:false
        }
    },
    methods:{
        handleClose1(){
            this.wxDialog = false
        },
        handleClose2(){
            this.dyDialog = false
        },
        openWxDialog(){
            this.wxDialog = true
        },
        openDyDialog(){
            this.dyDialog = true
        },
    }
}
</script>

<style scoped>
#mobileFootter{
    position: relative;
    height: 180px;
    background-color: #000000;
    width: 100%;
    z-index: 1;
}
.mobileFootter-tip1{
    font-size: 12px;
    font-weight: 500;
    color: rgba(255, 255, 255, .5);
    margin-right: 20.5px;
}
.mobileFootter-tip2{
    font-size: 12px;
    font-weight: 500;
    color: #FFFFFF;

}
.mobileFootter-tip3{
    width: 318.5px;
    height: 25px;
    background: rgba(255, 255, 255, 0.04);
    font-size: 12px;
    font-weight: 400;
    color: #FFFFFF;
    margin: 14px 0;
}
.mobileFootter-tip4{
    font-size: 12px;
    font-weight: 500;
    color: rgba(255, 255, 255, .5);
}
.mobileFootter-tip5{
    font-size: 10px;
    font-weight: 400;
    line-height: 16px;
    color: rgba(255, 255, 255, .5);
}
</style>


// WEBPACK FOOTER //
// src/components/mobileFootter.vue